/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { withAuth } from '@okta/okta-react';
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import React, { Component } from 'react';
import { checkAuthentication } from './helpers';
import pdf from './Nordstrom-SSO-FAQ.pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';

export default withAuth(class Help extends Component {
  constructor(props) {
    super(props);
    this.state = { authenticated: null, userinfo: null };
    this.checkAuthentication = checkAuthentication.bind(this);
  }

  async componentDidMount() {
    this.checkAuthentication();
  }

  async componentDidUpdate() {
    this.checkAuthentication();
  }

  render() {
    return (
      <div>
        {this.state.authenticated !== null &&
        <div>
          {this.state.authenticated &&
            <Document file={pdf} loading="">
              <Page pageNumber={1} scale={1.25} className="page" />
              <Page pageNumber={2} scale={1.25} className="page" />
              <Page pageNumber={3} scale={1.25} className="page" />
          </Document>
          }
          {!this.state.authenticated &&
            <div>
              Not Authenticated
            </div>
          }

        </div>
        }
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/Help.js